module.exports = "/packs/404-a4fab3dc4b72045c05a22b6038bb4d54.svg";